import { render, staticRenderFns } from "./TestTutorials.vue?vue&type=template&id=4a8c7d42&scoped=true&"
import script from "./TestTutorials.vue?vue&type=script&lang=js&"
export * from "./TestTutorials.vue?vue&type=script&lang=js&"
import style0 from "./TestTutorials.vue?vue&type=style&index=0&id=4a8c7d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c7d42",
  null
  
)

export default component.exports